import { Grid, TextField, MenuItem, Button } from '@material-ui/core';
import type { StyledComponentProps } from '@material-ui/core/styles';
import { GroupAddOutlined } from '@material-ui/icons';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import styles from './styles';

import type IUser from 'interfaces/IUser';
import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any>, StyledComponentProps {
  delivery: any;
  user: IUser;
  onRemovePartner: any;
  onAddPartner: any;
}

class Partner extends Component<IProps, any> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      added: false,
    };
    this.onConfirm = this.onConfirm.bind(this);
  }

  handleChange(prop: string, value: any) {
    let { delivery } = this.props;
    delivery[prop] = value;
    if (prop === 'partner' && !value) {
      let { onRemovePartner } = this.props;
      this.setState({ added: false });
      if (onRemovePartner) {
        onRemovePartner();
      }
    }
    this.props.dispatch({ type: 'CHANGE_PHYSICAL_DELIVERY', delivery });
  }

  onConfirm() {
    let { onAddPartner } = this.props;
    this.setState({ added: true });
    if (onAddPartner) {
      onAddPartner();
    }
  }

  render() {
    const { delivery, classes, user } = this.props;
    const { added } = this.state;

    if (user.email !== 'qa-orbita@eduzz.com') return null;
    return (
      <>
        <Grid item xs={12} md={8}>
          <TextField
            id='partner_id'
            select
            fullWidth
            value={delivery.partner_id}
            onChange={(e: any) => this.handleChange('partner_id', e.target.value)}
            label='Parceiro de logística'
            InputProps={{
              disableUnderline: true,
            }}
            InputLabelProps={{
              shrink: true,
            }}
          >
            <MenuItem value={16640004}>Kapsula Produtos Naturais Ltda</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} md={4}>
          <Button
            fullWidth
            color='primary'
            variant='contained'
            className={classes.buttonCopy}
            onClick={this.onConfirm}
            disabled={added || !delivery.partner_id}
            startIcon={<GroupAddOutlined />}
          >
            Adicionar novo parceiro
          </Button>
        </Grid>
      </>
    );
  }
}
function mapStateToProps(state: any) {
  return {
    delivery: state.components.physicalDelivery,
    user: state.orbita.User.user,
  };
}

export default connect(mapStateToProps)(styles(Partner));
